module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modalTitle": 'Edit Condition'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('FormulateForm', [_c('FormulateInput', {
    attrs: {
      "type": "select",
      "options": _vm.fieldOptions,
      "label": "Field",
      "validation": "required"
    },
    model: {
      value: (_vm.model.field),
      callback: function($$v) {
        _vm.$set(_vm.model, "field", $$v)
      },
      expression: "model.field"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "radio",
      "options": _vm.opOptions
    },
    model: {
      value: (_vm.model.op),
      callback: function($$v) {
        _vm.$set(_vm.model, "op", $$v)
      },
      expression: "model.op"
    }
  }), _vm._v(" "), (_vm.valuesOptions && _vm.model.op && _vm.model.op.arity == 2) ? _c('FormulateInput', {
    attrs: {
      "type": "select",
      "options": _vm.valuesOptions,
      "label": "Value(s)",
      "validation": "required"
    },
    model: {
      value: (_vm.model.values),
      callback: function($$v) {
        _vm.$set(_vm.model, "values", $$v)
      },
      expression: "model.values"
    }
  }) : (_vm.valuesOptions && _vm.model.op && _vm.model.op.arity == 'n') ? _c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "wrapper-class": ['multiple-choices'],
      "options": _vm.valuesOptions,
      "label": "Value(s)",
      "validation": "required"
    },
    model: {
      value: (_vm.model.values),
      callback: function($$v) {
        _vm.$set(_vm.model, "values", $$v)
      },
      expression: "model.values"
    }
  }) : (_vm.model.op && _vm.model.op.arity == 2) ? _c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Value",
      "validation": "required"
    },
    model: {
      value: (_vm.model.values),
      callback: function($$v) {
        _vm.$set(_vm.model, "values", $$v)
      },
      expression: "model.values"
    }
  }) : (_vm.model.op && _vm.model.op.arity == 'n') ? _c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Value(s)",
      "help": "Use a comma to separate values",
      "validation": "required"
    },
    model: {
      value: (_vm.model.values),
      callback: function($$v) {
        _vm.$set(_vm.model, "values", $$v)
      },
      expression: "model.values"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4134b54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/RuleModal.vue
// module id = 671
// module chunks = 0